// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';

import './EmptyElementToDrop.scss';

interface EmptyElementToDropProps {
    text: string;
}

const EmptyElementToDrop = ({ text }: EmptyElementToDropProps): ReactElement => {
    return <div className="empty-element">{text}</div>;
};

export default EmptyElementToDrop;
